import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Lot } from '../models/Lot';
import { Step4 } from '../../../../shared/models/component-messages/mapaIN/step4';
import { MapaINControlNames } from '../service/mapaINControleNames';

@Component({
  selector: 'app-lot',
  templateUrl: './lot.component.html'
})
export class LotComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Lot';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() nbIteration: number;

	@Input() lot: Lot;

    public step4 = new Step4();

  constructor() { }

  public ngOnInit() {}








  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

